<section aria-labelledby="multiple-price-change-modal-title" aria-modal="true" class="custom-modal" role="dialog">
  <header class="modal-header">
    <app-display-icon
      [border]="false"
      [colour]="iconColourEnum.primary"
      [icon]="icons.cashMultiple">
    </app-display-icon>
    <h2 class="modal-title" id="multiple-price-change-modal-title">Multiple Price Changes</h2>
    <button (click)="onClose()" aria-label="Close" class="icon-button" type="button">
      <app-display-icon
        [border]="false"
        [colour]="iconColourEnum.primary"
        [icon]="icons.closeCircleOutline">
      </app-display-icon>
    </button>
  </header>

  <div class="modal-body">
    <div class="item-summary">
      <div class="summary-cell">
        <span class="summary-label">Code</span>
        <span class="summary-value">{{ stockItem?.code }}</span>
      </div>
      <div class="summary-cell summary-cell-description">
        <span class="summary-label">Description</span>
        <span [title]="stockItem?.desc" class="summary-value">{{ stockItem?.desc }}</span>
      </div>
      <div class="summary-cell">
        <span class="summary-label">Latest Cost</span>
        <span class="summary-value">{{ latestCost() | number: '1.2-2' }}</span>
      </div>
      <div class="summary-cell">
        <span class="summary-label">Retail Price 1</span>
        <span class="summary-value">{{ sellPriceIncluding1() | number: '1.2-2' }}</span>
      </div>
      <div class="summary-cell">
        <span class="summary-label">Price 1 GP</span>
        <span class="summary-value">{{ priceOneGp() | number: '1.2-2' }}%</span>
      </div>
    </div>

    @if (results().length === 0) {
      <p class="empty-state">No other prices change for this item.</p>
    } @else {
      <table class="price-change-table">
        <thead>
        <tr>
          <th scope="col">Price</th>
          <th scope="col">Was</th>
          <th scope="col">Now</th>
          <th scope="col">GP</th>
          <th scope="col">Rule</th>
        </tr>
        </thead>
        <tbody>
          @for (result of results(); track result.priceIndex) {
            <tr>
              <td>Price {{ result.priceIndex }}</td>
              <td>{{ result.previousInclusive | number: '1.2-2' }}</td>
              <td class="new-price">{{ result.inclusive | number: '1.2-2' }}</td>
              <td>{{ result.effectiveGp | number: '1.2-2' }}%</td>
              <td class="rule-cell">{{ describeResult(result) }}</td>
            </tr>
          }
        </tbody>
      </table>
      <p class="footer-note">
        These prices are VAT inclusive and are submitted to IQ together with retail price 1.
      </p>
    }
  </div>

  <footer class="modal-footer">
    <app-shared-button (click)="onClose()" [fill]="true">Close</app-shared-button>
  </footer>
</section>
